<template>
  <section class="app-wiki-wapper">
    <CommonDocumentMain :prefix-path="`/${$route.params.lang}/wiki`" />
    <div class="mt-6 flex justify-end"><CommonBackToTop /></div>
  </section>
</template>
<script lang="ts" setup>
useRouteCache((route) => {
  route.setCacheable().setMaxAge(300).addTags(['docs-detail-page-cache-tag'])
})

const route = useRoute()
const documentStore = useDocumentStore()
const { fetchDocumentDetail } = documentStore
await fetchDocumentDetail(route.params.id as string, 'tutorial')
</script>
<style lang="scss" scoped></style>
